import fermentedMilkCategoryCoverImage from '../../../assets/images/fermentedMilkProducts/fermentedMilkCategoryCoverImage.webp'
import fermentedMilkCategoryCoverImageMobile from '../../../assets/images/fermentedMilkProducts/fermentedMilkCategoryCoverImageMobile.webp'
import sourCreamPastoral1 from '../../../assets/images/fermentedMilkProducts/sour-cream-30-fat-pastoral-200g.webp'
import sourCreamPastoral2 from '../../../assets/images/fermentedMilkProducts/sour-cream-30-fat-pastoral-400g.webp'
import kefirMumulya1 from '../../../assets/images/fermentedMilkProducts/kefir-1-fat-mumulya-400g.webp'
import kefirMumulya2 from '../../../assets/images/fermentedMilkProducts/kefir-1-fat-mumulya-900g.webp'
import kefirMumulya3 from '../../../assets/images/fermentedMilkProducts/kefir-2-5-fat-mumulya-400g.webp'
import kefirMumulya4 from '../../../assets/images/fermentedMilkProducts/kefir-2-5-fat-mumulya-900g.webp'
import sourCreamMumulya1 from '../../../assets/images/fermentedMilkProducts/sour-cream-15-fat-mumulya-400g.webp'
import sourCreamMumulya2 from '../../../assets/images/fermentedMilkProducts/sour-cream-20-fat-mumulya-400g.webp'
import yogurtPeach1 from '../../../assets/images/fermentedMilkProducts/yogurt-peach-2-5-fat-mumulya-400g.webp'
import yogurtPeach2 from '../../../assets/images/fermentedMilkProducts/yogurt-peach-2-5-fat-mumulya-115g.webp'
import yogurtStrawberry1 from '../../../assets/images/fermentedMilkProducts/yogurt-strawberry-2-5-fat-mumulya-400g.webp'
import yogurtStrawberry2 from '../../../assets/images/fermentedMilkProducts/yogurt-strawberry-2-5-fat-mumulya-115g.webp'
import yogurtForestBerries1 from '../../../assets/images/fermentedMilkProducts/yogurt-forest-berries-2-5-fat-mumulya-400g.webp'
import yogurtForestBerries2 from '../../../assets/images/fermentedMilkProducts/yogurt-forest-berries-2-5-fat-mumulya-115g.webp'

export const FermentedMilkProductsArrRu = [
    {
        path: "/ru/fermented-milk-products/sour-cream-30-fat-pastoral-200g/",
        category: "fermentedMilk",
        metaTitle: "Сметана 30% жирности ТМ «Pastoral",
        metaDescription: "Сметана 30% жирности ТМ «Pastoral» 200 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: sourCreamPastoral1,
        aboutTitle: "Сметана 30% жирности ТМ «Pastoral» 200 g (г)",
        aboutStats: [
            "2,4 g (г)", "30,0 g (г)", "2,7 g (г)", "294 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "200 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "Cтакан",
            },
            {
                title: "Состав: ",
                desc: "сливки из коровьего молока, бактериальная закваска. Общее количество жизнеспособных молочнокислых бактерий — не менее 1×10⁷ КОЕ в 1 см³.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>с даты производства при температуре (4±2)°С не более 21 суток.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ У 25027034-009-99",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    {
        path: "/ru/fermented-milk-products/sour-cream-30-fat-pastoral-400g/",
        category: "fermentedMilk",
        metaTitle: "Сметана 30% жирности ТМ «Pastoral» 400 g (г)",
        metaDescription: "Сметана 30% жирности ТМ «Pastoral» 400 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: sourCreamPastoral2,
        aboutTitle: "Сметана 30% жирности ТМ «Pastoral» 400 g (г)",
        aboutStats: [
            "2,4 g (г)", "30,0 g (г)", "2,7 g (г)", "294 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "400 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "Фольга",
            },
            {
                title: "Состав: ",
                desc: "сливки из коровьего молока, бактериальная закваска. Общее количество жизнеспособных молочнокислых бактерий — не менее 1×10⁷ КОЕ в 1 см³.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>с даты производства при температуре (4±2)°С не более 21 суток.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ У 25027034-009-99",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    {
        path: "/ru/fermented-milk-products/kefir-1-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Кефир 1,0% жирности ТМ «МУМУЛЯ» 400 g (г)",
        metaDescription: "Кефир 1,0% жирности ТМ «МУМУЛЯ» 400 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: kefirMumulya1,
        aboutTitle: "Кефир 1,0% жирности ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "3,0 g (г)", "1,0 g (г)", "3,5 g (г)", "39 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "400 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "полиэтиленовая плёнка",
            },
            {
                title: "Состав: ",
                desc: "цельное коровье молоко, обезжиренное коровье молоко, бактериальная закваска.Общее количество жизнеспособных молочнокислых бактерий — не менее 1×10⁷ КОЕ в 1 см³.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>при температуре (4±2)°С не более 14 суток.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ У 25027034-011-99",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    {
        path: "/ru/fermented-milk-products/kefir-1-fat-mumulya-900g/",
        category: "fermentedMilk",
        metaTitle: "Кефир 1,0% жирности ТМ «МУМУЛЯ» 900 g (г)",
        metaDescription: "Кефир 1,0% жирности ТМ «МУМУЛЯ» 900 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: kefirMumulya2,
        aboutTitle: "Кефир 1,0% жирности ТМ «МУМУЛЯ» 900 g (г)",
        aboutStats: [
            "3,0 g (г)", "1,0 g (г)", "3,5 g (г)", "39 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "900 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "полиэтиленовая плёнка",
            },
            {
                title: "Состав: ",
                desc: "цельное коровье молоко, обезжиренное коровье молоко, бактериальная закваска. Общее количество жизнеспособных молочнокислых бактерий — не менее 1×10⁷ КОЕ в 1 см³.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>при температуре (4±2)°С не более 14 суток.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ У 25027034-011-99",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    {
        path: "/ru/fermented-milk-products/kefir-2-5-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Кефир 2,5% жирности ТМ «МУМУЛЯ» 400 g (г)",
        metaDescription: "Кефир 2,5% жирности ТМ «МУМУЛЯ» 400 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: kefirMumulya3,
        aboutTitle: "Кефир 2,5% жирности ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "3,0 g (г)", "2,5 g (г)", "3,5 g (г)", "53 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "400 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "полиэтиленовая плёнка",
            },
            {
                title: "Состав: ",
                desc: "цельное коровье молоко, обезжиренное коровье молоко, бактериальная закваска. Общее количество жизнеспособных молочнокислых бактерий — не менее 1×10⁷ КОЕ в 1 см³.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>при температуре (4±2)°С не более 14 суток.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ У 25027034-011-99",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    {
        path: "/ru/fermented-milk-products/kefir-2-5-fat-mumulya-900g/",
        category: "fermentedMilk",
        metaTitle: "Кефир 2,5% жирности ТМ «МУМУЛЯ» 900 g (г)",
        metaDescription: "Кефир 2,5% жирности ТМ «МУМУЛЯ» 900 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: kefirMumulya4,
        aboutTitle: "Кефир 2,5% жирности ТМ «МУМУЛЯ» 900 g (г)",
        aboutStats: [
            "3,0 g (г)", "2,5 g (г)", "3,5 g (г)", "53 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "900 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "полиэтиленовая плёнка",
            },
            {
                title: "Состав: ",
                desc: "цельное коровье молоко, обезжиренное коровье молоко, бактериальная закваска. Общее количество жизнеспособных молочнокислых бактерий — не менее 1×10⁷ КОЕ в 1 см³.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>при температуре (4±2)°С не более 14 суток.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ У 25027034-011-99",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    {
        path: "/ru/fermented-milk-products/sour-cream-15-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Сметана 15% жирности ТМ «МУМУЛЯ» 400 g (г)",
        metaDescription: "Сметана 15% жирности ТМ «МУМУЛЯ» 400 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: sourCreamMumulya1,
        aboutTitle: "Сметана 15% жирности ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "3,0 g (г)", "15,0 g (г)", "3,0 g (г)", "159 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "400 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "полиэтиленовая плёнка",
            },
            {
                title: "Состав: ",
                desc: "сливки из коровьего молока, бактериальная закваска. Общее количество жизнеспособных молочнокислых бактерий — не менее 1×10⁷ КОЕ в 1 см³.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>с даты производства при температуре (4±2)°С не более 21 суток.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ У 25027034-009-99",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    {
        path: "/ru/fermented-milk-products/sour-cream-20-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Сметана 20% жирности ТМ «МУМУЛЯ» 400 g (г)",
        metaDescription: "Сметана 20% жирности ТМ «МУМУЛЯ» 400 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: sourCreamMumulya2,
        aboutTitle: "Сметана 20% жирности ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "2,8 g (г)", "20,0 g (г)", "3,0 g (г)", "212,2 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "400 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "полиэтиленовая плёнка",
            },
            {
                title: "Состав: ",
                desc: "сливки из коровьего молока, бактериальная закваска.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>с даты производства при температуре (4±2)°С не более 21 суток.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ У 25027034-009-99",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    {
        path: "/ru/fermented-milk-products/yogurt-peach-2-5-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Йогурт с кусочками персика 2,5% жирности ТМ «МУМУЛЯ» 400 g (г)",
        metaDescription: "Йогурт с кусочками персика 2,5% жирности ТМ «МУМУЛЯ» 400 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: yogurtPeach1,
        aboutTitle: "Йогурт с кусочками персика 2,5% жирности ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "2,75 g (г)", "2,5 g (г)", "10,78 g (г)", "76,62 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "400 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "полиэтиленовая плёнка",
            },
            {
                title: "Состав: ",
                desc: "цельное коровье молоко, обезжиренное коровье молоко, сахар-песок, пастеризованный фруктовый наполнитель «Персик» (белый кристаллический сахар — 54%, персик — 35%, модифицированный кукурузный крахмал Е1442, регулятор кислотности цитрат натрия Е331, ароматизатор «персик», краситель бета-каротин Е160а), сухое обезжиренное молоко, бактериальная закваска для йогурта.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>с даты производства при температуре (4±2)°С не более 14 суток.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ДСТУ 4343:2004",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    {
        path: "/ru/fermented-milk-products/yogurt-peach-2-5-fat-mumulya-115g/",
        category: "fermentedMilk",
        metaTitle: "Йогурт с кусочками персика 2,5% жирности ТМ «МУМУЛЯ» 115 g (г)",
        metaDescription: "Йогурт с кусочками персика 2,5% жирности ТМ «МУМУЛЯ» 115 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: yogurtPeach2,
        aboutTitle: "Йогурт с кусочками персика 2,5% жирности ТМ «МУМУЛЯ» 115 g (г)",
        aboutStats: [
            "2,75 g (г)", "2,5 g (г)", "10,78 g (г)", "76,62 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "115 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "стакан",
            },
            {
                title: "Состав: ",
                desc: "цельное коровье молоко, обезжиренное коровье молоко, сахар-песок, пастеризованный фруктовый наполнитель «Персик» (белый кристаллический сахар — 54%, персик — 35%, модифицированный кукурузный крахмал Е1442, регулятор кислотности цитрат натрия Е331, ароматизатор «персик», краситель бета-каротин Е160а), сухое обезжиренное молоко, бактериальная закваска для йогурта.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>с даты производства при температуре (4±2)°С не более 14 суток.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ 15.5.25027034-019-01",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    {
        path: "/ru/fermented-milk-products/yogurt-strawberry-2-5-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Йогурт с кусочками клубники 2,5% жирности ТМ «МУМУЛЯ» 400 g (г)",
        metaDescription: "Йогурт с кусочками клубники 2,5% жирности ТМ «МУМУЛЯ» 400 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: yogurtStrawberry1,
        aboutTitle: "Йогурт с кусочками клубники 2,5% жирности ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "2,75 g (г)", "2,5 g (г)", "10,78 g (г)", "76,62 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "400 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "полиэтиленовая плёнка",
            },
            {
                title: "Состав: ",
                desc: "цельное коровье молоко, обезжиренное коровье молоко, сахар-песок, пастеризованный фруктовый наполнитель «Клубника» (белый кристаллический сахар — 42%, клубника — 40%, модифицированный кукурузный крахмал Е1442, пектин Е1440, регуляторы кислотности: лимонная кислота Е330 и цитрат натрия Е331, ароматизаторы: клубника и ваниль, красители: восстановленный свекольный сок, кармин Е120), сухое обезжиренное молоко, бактериальная закваска для йогурта.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>с даты производства при температуре (4±2)°С не более 14 суток</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ДСТУ 4343:2004",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    {
        path: "/ru/fermented-milk-products/yogurt-strawberry-2-5-fat-mumulya-115g/",
        category: "fermentedMilk",
        metaTitle: "Йогурт с кусочками клубники 2,5% жирности ТМ «МУМУЛЯ» 115 g (г)",
        metaDescription: "Йогурт с кусочками клубники 2,5% жирности ТМ «МУМУЛЯ» 115 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: yogurtStrawberry2,
        aboutTitle: "Йогурт с кусочками клубники 2,5% жирности ТМ «МУМУЛЯ» 115 g (г)",
        aboutStats: [
            "2,75 g (г)", "2,5 g (г)", "10,78 g (г)", "76,62 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "115 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "стакан",
            },
            {
                title: "Состав: ",
                desc: "цельное коровье молоко, обезжиренное коровье молоко, сахар-песок, пастеризованный фруктовый наполнитель «Клубника» (белый кристаллический сахар – 42%, клубника – 40%, модифицированный кукурузный крахмал Е1442, пектин Е1440, регуляторы кислотности: лимонная кислота Е330 и цитрат натрия Е331, ароматизаторы: клубника и ваниль, красители: восстановленный сок красной свёклы, кармин Е120), обезжиренное сухое молоко, бактериальная закваска для йогурта.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>с даты производства при температуре (4±2)°С не более 14 суток.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ 15.5.25027034-019-01",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    {
        path: "/ru/fermented-milk-products/yogurt-forest-berries-2-5-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Йогурт с кусочками лесных ягод 2,5% жирности ТМ «МУМУЛЯ» 400 g (г)",
        metaDescription: "Йогурт с кусочками лесных ягод 2,5% жирности ТМ «МУМУЛЯ» 400 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: yogurtForestBerries1,
        aboutTitle: "Йогурт с кусочками лесных ягод 2,5% жирности ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "2,75 g (г)", "2,5 g (г)", "10,78 g (г)", "76,62 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "400 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "полиэтиленовая плёнка",
            },
            {
                title: "Состав: ",
                desc: "цельное коровье молоко, обезжиренное коровье молоко, сахар-песок, пастеризованный фруктовый наполнитель «Лесная ягода» (белый кристаллический сахар – 53%, фрукты – 35% (ежевика, малина, клубника, черника, чёрная смородина), модифицированный крахмал Е1442, регуляторы кислотности: лимонная кислота Е330 и цитрат натрия Е331, ароматизатор клубники, краситель кармин Е120), обезжиренное сухое молоко, бактериальная закваска для йогурта.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>: с даты производства при температуре (4±2)°С не более 14 суток</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ДСТУ 4343:2004",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    {
        path: "/ru/fermented-milk-products/yogurt-forest-berries-2-5-fat-mumulya-115g/",
        category: "fermentedMilk",
        metaTitle: "Йогурт с кусочками лесных ягод 2,5% жирности ТМ «МУМУЛЯ» 115 g (г)",
        metaDescription: "Йогурт с кусочками лесных ягод 2,5% жирности ТМ «МУМУЛЯ» 115 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочные продукты",
        aboutImage: yogurtForestBerries2,
        aboutTitle: "Йогурт с кусочками лесных ягод 2,5% жирности ТМ «МУМУЛЯ» 115 g (г)",
        aboutStats: [
            "2,75 g (г)", "2,5 g (г)", "10,78 g (г)", "76,62 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "115 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "стакан",
            },
            {
                title: "Состав: ",
                desc: "цельное коровье молоко, обезжиренное коровье молоко, сахар-песок, пастеризованный фруктовый наполнитель «Лесная ягода» (белый кристаллический сахар – 53%, фрукты – 35% (ежевика, малина, клубника, черника, чёрная смородина), модифицированный крахмал Е1442, регуляторы кислотности: лимонная кислота Е330 и цитрат натрия Е331, ароматизатор клубники, краситель кармин Е120), обезжиренное сухое молоко, бактериальная закваска для йогурта.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>с даты производства при температуре (4±2)°С не более 14 суток.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ 15.5.25027034-019-01",
            },
        ],
        categoryInfo: [
            "Контроль всех процессов производства и деликатный процесс сквашивания.",
            "Бактериальная закваска от европейского производителя.",
            "Натуральный источник белка, кальция и полезных молочнокислых культур.",
            "Густая консистенция, бархатистая текстура, нежный сливочный вкус с легкой кислинкой.",
    
        ],
    },
    
]